/*
 * Accent scope: derives every accent token consumers need — `--agent-accent`
 * plus the pre-mixed `--agent-accent-stroke` / `--agent-accent-bubble-bg` —
 * from the single resolved `backgroundColor`, without adding a box
 * (`display: contents` means this div contributes no layout of its own).
 *
 * Deriving the `color-mix()` here (not in the consumer CSS module) is
 * Joni's binding invariant: consumers only ever read the derived var with a
 * neutral fallback (`var(--agent-accent-stroke, <neutral>)`), never compute
 * `color-mix()` themselves. A consumer-side `color-mix(var(--x, fallback))`
 * still evaluates when `--x` is unset — the fallback participates in the mix
 * instead of short-circuiting it — so the "unset var → byte-identical
 * neutral" contract only holds if the mix happens where the var is always
 * set. Set ONLY here (and in AgentIdentityHeader's own module, for its own
 * `--agent-accent-header-bg`) so the human Chat tool, which never mounts
 * AgentChat, renders byte-identically.
 */
.accentScope {
  display: contents;
}

/*
 * Focus chip rendered above the agent composer when the user has just
 * clicked a block affordance (e.g. "Ask chord advisor"). One-shot:
 * consumed on submit or dismissed via the × button.
 */
.focusChip {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-0_5, 4px);
  padding: 2px 8px;
  margin: 4px 0;
  background: var(--tuna-surface-elevated, var(--tuna-palette-background-paper));
  border: 1px solid var(--tuna-palette-divider, rgba(0, 0, 0, 0.12));
  border-radius: var(--tuna-shape-radius-pill);
  font-size: var(--tuna-typography-fontSize-xs);
  line-height: 1.4;
  color: var(--tuna-content-secondary);
}

.focusChip button {
  background: none;
  border: 0;
  padding: 0 2px;
  cursor: pointer;
  color: inherit;
  font-size: var(--tuna-typography-fontSize-md);
  line-height: 1;
}

.focusChip button:hover,
.focusChip button:focus-visible {
  color: var(--tuna-content-primary);
}

.focusChip button:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}
